import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import ScreenHeader from './ScreenHeader';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import ChatSupportButton from './ChatSupportButton';
import '../mobile.css';

// Wraps every /m/* screen with the shared header/footer/support-button chrome.
// ScreenHeader mirrors the native Stack Navigator chrome (back arrow, title,
// home icon) every mobile screen gets from App.js's Stack.Screen options;
// AppHeader mirrors the separate in-content user-info/logout bar mobile
// screens render themselves (MyCases, dashboard, etc). On web, AppHeader is
// placed above ScreenHeader (a deliberate deviation from the app's actual
// layout, where the native header is always outermost) since "who am I /
// logout" reads better as the most persistent, outermost element on web.
const MobileLayout = () => {
  const [footerLoading, setFooterLoading] = useState(false);

  return (
    <div className="m-screen">
      <AppHeader />
      <ScreenHeader />
      <div className="m-content" id="m-scroll-content">
        <Outlet context={{ setFooterLoading }} />
      </div>
      <AppFooter loading={footerLoading} />
      <ChatSupportButton />
    </div>
  );
};

export default MobileLayout;
